// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2mbWQ","buttons":"RemoveExpirationActionButtons_buttons__2Ta2Y"};